export default __webpack_public_path__ + "static/media/img-5.9fdcfbe9.jpg";